'use client';

import { createContext } from 'react';

import type { UpsellRootContextInterface } from '../types/upsell-root.types';

export const UpsellRootContext = createContext<UpsellRootContextInterface>({});

UpsellRootContext.displayName = 'Upsell.Root.Context';
